module.exports = __webpack_public_path__ + "img/nato.9bdb5bde.svg";